export interface ISalesCustomerInfo {
  salesChannelName: string
  salesChannelAdminName: string
  salesChannelAdminEmail: string
}

export interface IProductInfo {
  utility: string
  commodity: string
  customerType: string
  term?: number
  terminationFee?: number
  serviceFee?: number
  chooseProducts: string
}

export interface IAgentInfo {
  agentFirstName: ''
  agentLastName: ''
  agentEmailID: ''
}

export interface ISCEnrollmentData {
  customerInfo: ISalesCustomerInfo
  productInfo: IProductInfo
  agentInfo: IAgentInfo
}

export const defaultChannelEnrollment = {
  salesChannelName: '',
  salesChannelAdminFirstName: '',
  salesChannelAdminLastName: '',
  repId: '',
  salesChannelAdminEmail: '',
  utility: '',
  commodity: '',
  customerType: '',
  chooseProducts: '',
  agentFirstName: '',
  agentLastName: '',
  agentEmailID: '',
  productIds: [],
  ivr: false,
  liveAgent: false,
  enableNoTPV: false,
  enableTelephoneViewForSalesAdmin: false,
  textTpv: false,
  smsD2D: false,
  emailD2D: false,
  enableContractRequired: false,
  outboundLiveAgent: false,
  enableCustomerBillImage: false,
  enableMultipleUan: false,
  agentLeaders: [],
  salesChannelType: '',
  agent: [
    {
      agentEmailId: '',
      agentFirstName: '',
      agentLastName: '',
      agentRepId: '',
      UserName: '',
      agentPassword: '',
    },
  ],
}

export type StepProps = {
  data: ISCEnrollmentData
  updateData: (fieldsToUpdate: Partial<ISCEnrollmentData>) => void
  hasError: boolean
  formik: any
  hasFieldError: boolean
  method: any
  validEmail?: any
  handleEmailValidation?: any
  setActiveStatus?: any
  activeStatus?: boolean
  isUploadMode?: any
  setIsUploadMode?: any

  // fieldArray : any
}

export const defaultSalesChannelInfo = {
  salesChannelName: '',
  salesChannelAdminFirstName: '',
  salesChannelAdminLastName: '',
  salesChannelRepId: '',
  salesChannelAdminEmail: '',
  ivr: false,
  enableNoTPV: false,
  liveAgent: false,
  textTpv: false,
  smsD2D: false,
  emailD2D: false,
  outboundLiveAgent: false,
  enableContractRequired: false,
  enableCustomerBillImage: false,
  enableTelephoneViewForSalesAdmin: false,
  enableMultipleUan: false,
  salesChannelType: '',
}

export const defaultSalesChannelProductInfo = {
  utility: '',
  commodity: '',
  customerType: '',
  term: '',
  terminationFee: '',
  serviceFee: '',
  productIds: [],
  deletedProductId: [],
}

//types
export type formikAgentType = {
  salesChannelName: string
  salesChannelAdminFirstName: string
  salesChannelAdminLastName: string
  salesChannelAdminEmail: string
  utility: string
  commodity: string
  customerType: string
  chooseProducts: string
  agentFirstName: string
  agentLastName: string
  agentEmailID: string
  productIds: string[]
  ivr: boolean
  liveAgent: boolean
  textTpv: boolean
  smsD2D: boolean
  emailD2D: boolean
  outboundLiveAgent: boolean
  agentLeaders: {
    leaderName: string
    leaderCode: string
  }[]
}
